module.exports = __webpack_public_path__ + "img/tu.f5497e55.png";